export const formatYoutubeURL = (url?: string) => {
  if (!url) return;
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);

  // eslint-disable-next-line consistent-return
  return match && match[7].length == 11 ? match[7] : undefined;
};
